<template>
  <section class="row items-center">
    <q-img :src="urlFoto"
        v-if="!erro"
        :alt="alt"
        :style="styleFoto"
        :class="classeFoto"
        @error="erro = !erro"
    />
    <q-img  v-else src="../assets/no-image.png"/>
  </section>
</template>

<script>
import { ref } from 'vue'
export default {
    name:'QImagemFoto',
    props: {
        url: {
            type: String,
            default: ''
        },
        altImg: {
            type: String,
            default: ''
        },
        classeImg: {
            type: String,
            default: ''
        },
        styleImg: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const urlFoto = ref(props.url)
        const altFoto = ref(props.alt)
        const classeFoto = ref(props.classeImg)
        const styleFoto = ref(props.style)
        const erro = ref(false)
        return {
            urlFoto,
            erro,
            altFoto,
            classeFoto,
            styleFoto
        }
    }
}
</script>

<style>

</style>